
import MapBox from './../modules/map'
import { CityPoupComponent } from './../components/CityPopup/CityPopup'
import { DetailsPanel } from '../sections/luxury-yachting/components/DetailsPanel/DetailsPanel'
import { EventDetailsPanel } from './../components/EventDetailsPanel/EventDetailsPanel'
import { ISO_3166_MAPPER } from '../data/ISO_3166_MAPPER'
import { COUNTRY_DETAILS } from '../data/country-details'

export class CitiesModule {
  cities = []
  showCities = false
  constructor() { }

  initialize(cities, showCities = false) {
    this.showCities = showCities

    // If for any reasons a city won't have a city data, then we don't want to display it on the map
    const citiesWithCityAndCountryData = cities.filter(city => city.cityData !== null && city.countryData !== null)
    const citiesWithoutCityData = cities.filter(city => city.cityData === null || city.countryData === null)
    // We want to leave a warning message as this could be hard to find out if reported that some cities are not showing and they should
    console.warn('Found some of the cities that do not have any city data: ', citiesWithoutCityData)

    console.log('citiesWithCityAndCountryData', citiesWithCityAndCountryData)
    this.cities = citiesWithCityAndCountryData.map(city => {
      const countryCodeAlpha3 = this._getAlpha3ISOCode(city.cityData.countryCode)

      // International SOS has 2 systems for medical rating and we use one which varies from 7-10, for simplicity and to avoid confusion
      // we are going to reduce it to values from 1-4
      let medicalRating = 0
      if (city.countryData !== null) medicalRating = city.countryData.medicalrisk
      if (medicalRating > 0) medicalRating -= 6

      let cityData = {
        ['longitude']: city.cityData.longitude,
        ['latitude']: city.cityData.latitude,
        ['ISO_3166_1_ALPHA_2']: city.cityData.countryCode,
        ['ISO_3166_1_ALPHA_3']: countryCodeAlpha3,
        ['cityName']: city.name,
        ['countryName']: city.countryData.name !== '' ? city.countryData.name : this._getCountryName(countryCodeAlpha3),
        ['cityRating']: city.travelrisk,
        ['countryRating']: city.countryData.travelrisk,
        ['countryMedicalRating']: medicalRating
      }

      return cityData
    })

    this.display()
    this.initializeEventListeners()
  }

  _getAlpha3ISOCode(ISO_3166_1_ALPHA_2) {
    for (const key in ISO_3166_MAPPER) {
      if (ISO_3166_MAPPER[key] === ISO_3166_1_ALPHA_2) {
        return key
      }
    }

    return null
  }

  _getCountryName(ISO_3166_1_ALPHA_3) {
    const countryDetails = COUNTRY_DETAILS.find(country => country.ISO_3166_1_ALPHA_3 === ISO_3166_1_ALPHA_3)
    return countryDetails !== undefined ? countryDetails.name : ''
  }

  getCities() {
    return this.cities
  }

  getFeatureCollection(cities) {
    const featureCollection = {
      type: 'FeatureCollection',
      features: []
    }

    for (const city of cities) {

      const point = {
        type: 'Point',
        coordinates: [city.longitude, city.latitude]
      }

      const feature = {
        type: 'Feature',
        id: `${city.ISO_3166_1_ALPHA_3}_${city.latitude}_${city.longitude}`,
        geometry: point,
        properties: city
      }
      featureCollection.features.push(feature)
    }

    return featureCollection
  }

  display() {
    const citiesFeatureCollection = this.getFeatureCollection(this.cities)

    const cityLayers = MapBox.map.getSource('cities')
    if (cityLayers !== undefined) {
      cityLayers.setData(citiesFeatureCollection)
    } else {

      MapBox.map.addSource('cities', {
        'type': 'geojson',
        'data': citiesFeatureCollection
      })

      MapBox.map.addLayer({
        id: 'cities',
        type: 'symbol',
        source: 'cities',
        paint: {
          'text-color': '#ffffff',
          'text-halo-width': 1,
          'text-halo-color': '#000000'
        },
        layout: {
          'visibility': this.showCities ? 'visible' : 'none',
          'icon-image': 'airport-marker',
          'icon-allow-overlap': true,
          'text-allow-overlap': false,
          'icon-size': .5,
          'text-size': ['interpolate', ['linear'], ['zoom'], 0, 8, 3.5, 12, 4.5, 15, 7, 17],
          'text-field': ['get', 'cityName'],
          'text-font': [
            'Open Sans Semibold',
            'Arial Unicode MS Bold'
          ],
          'text-offset': [0, 1],
          'text-anchor': 'top'
        }
      })

      this.updateCityRiskIcons()

    }
  }

  updateCityRiskIcons() {
    MapBox.map.setLayoutProperty('cities', 'icon-image', [
      'match',
      ['get', 'cityRating'],
      1, 'airport-marker-1',
      2, 'airport-marker-2',
      3, 'airport-marker-3',
      4, 'airport-marker-4',
      5, 'airport-marker-5',
      'airport-marker'
    ])
  }

  show() {
    this.showCities = true
    MapBox.map.setLayoutProperty('cities', 'visibility', 'visible')
  }

  hide() {
    this.showCities = false
    MapBox.map.setLayoutProperty('cities', 'visibility', 'none')
  }

  showCity(cityData) {
    // Because of the design and the implementation, we need to assure we hide other panels nicely 
    // We need it for better UI experience, e.g. user clicks on the airport when the event panel is opened
    // By default event panel slides back to right and airport panel slides left to be displayed that causes a very weird
    // jumping animation, so we wait for the event panel to go back nicely and the slide in nicely the airport panel
    if (EventDetailsPanel.isPanelOpen) {
      EventDetailsPanel.hidePanel()

      const timeout = window.setTimeout(() => {
        DetailsPanel.showDetailsPanel(cityData, 'city')
        window.clearTimeout(timeout)
      }, 500)
    } else {
      DetailsPanel.showDetailsPanel(cityData, 'city')
    }

    this.flyToCity(cityData)
  }

  flyToCity(cityData) {
    if (cityData.latitude && cityData.longitude) {
      MapBox.map.flyTo({ center: ['' + cityData.longitude, '' + cityData.latitude], zoom: 8 })
    }
  }

  initializeEventListeners() {
    MapBox.map.on('mouseenter', 'cities', (e) => {
      CityPoupComponent.$data.display = 'block'
      CityPoupComponent.$data.opacity = 1

      var cityData = e.features[0].properties

      CityPoupComponent.$data.city = cityData.cityName
      CityPoupComponent.$data.country = cityData.countryName
      CityPoupComponent.$data.cityRating = cityData.cityRating
      CityPoupComponent.$data.countryRating = cityData.countryRating

      // Change the cursor style as a UI indicator
      MapBox.map.getCanvas().style.cursor = 'pointer'
    })

    MapBox.map.on('mouseleave', 'cities', () => {
      CityPoupComponent.$data.display = 'none'
      CityPoupComponent.$data.opacity = 0
      MapBox.map.getCanvas().style.cursor = 'inherit'
    })

    MapBox.map.on('mousemove', 'cities', (e) => {
      CityPoupComponent.$data.leftPosition = e.point.x + 15 + 'px'
      CityPoupComponent.$data.topPosition = e.point.y + 15 + 'px'
    })
  }
}

const Cities = new CitiesModule()
export default Cities
